import { render } from "./Footer.vue?vue&type=template&id=454f1a1c&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=454f1a1c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454f1a1c"]])

export default __exports__